import type { RouteLocationNormalizedLoaded, Router } from 'vue-router'

export const PLACE_ON_MAP_QUERY = 'place'

export function isPlaceOnMapQuery(query: Record<string, unknown>): boolean {
  return String(query[PLACE_ON_MAP_QUERY] ?? '') === '1'
}

export function parsePlaceObjectIdFromQuery(query: Record<string, unknown>): number | null {
  if (!isPlaceOnMapQuery(query)) return null
  const first = String(query.ids ?? '')
    .split(',')[0]
    ?.trim()
  const id = Number(first)
  return Number.isFinite(id) && id > 0 ? id : null
}

/**
 * Route location for the group map tab (view or place mode).
 */
export function buildInventoryMapRoute(
  route: RouteLocationNormalizedLoaded,
  objectListId: number,
  options?: { place?: boolean; focus?: boolean },
) {
  const { invent_type_id: _inventTypeId, invent_object_id: _inventObjectId, ...params } = route.params

  const query: Record<string, string> = { ...route.query, ids: String(objectListId) }
  if (options?.place) query[PLACE_ON_MAP_QUERY] = '1'
  else delete query[PLACE_ON_MAP_QUERY]
  if (options?.focus) query.focus = '1'
  else delete query.focus

  return {
    name: `objects.${String(params.type)}.map`,
    params: { ...params, tab: 'map' },
    query,
  }
}

export function navigateToMapView(router: Router, route: RouteLocationNormalizedLoaded, objectListId: number) {
  return router.push(buildInventoryMapRoute(route, objectListId, { focus: true }))
}

export function navigateToPlaceOnMap(
  router: Router,
  route: RouteLocationNormalizedLoaded,
  objectListId: number,
) {
  return router.push(buildInventoryMapRoute(route, objectListId, { place: true }))
}

export function clearPlaceOnMapQuery(
  router: Router,
  route: RouteLocationNormalizedLoaded,
) {
  const query = { ...route.query }
  delete query[PLACE_ON_MAP_QUERY]
  return router.replace({ ...route, query })
}
